module.exports = __webpack_public_path__ + "img/abort-dark.888cb772.svg";